import styled from "styled-components";
// import '../../../node_modules/mdbreact/dist/css/mdb.css';

export const Container = styled.div`
    /* float:left;  */
    width:100%; 
    /* max-width: 1800px; */
    position:relative;  
    padding-right: 3px;
    margin: 0 auto;

    padding-bottom: 95px;
`;

export const TituloPagina = styled.h1`
	margin-top: 120px;
	font-size: 25px;
	font-weight: 300;
	text-align: center;
	line-height: 35px;
	color: rgb(86, 86, 86);
`

export const HomeFornada = styled.form`
    .botao-consultar {
        background: #388e3c !important;
        padding: 0.5rem 1.4rem;
        font-size: .64rem;
        color: #FFF;
        border-radius: 3px;
        text-transform: uppercase;
        transition: all 0.5s;
    }
    .botao-consultar:hover { 
       filter: brightness(1.2);
    }
    .botao-detalhes {
        background: #043c54 !important;
        padding: 0.5rem 1.4rem;
        font-size: .64rem;
        color: #FFF;
        border-radius: 3px;
        text-transform: uppercase;
        transition: all 0.5s;
    }
    .botao-detalhes:hover { 
       filter: brightness(1.2);
    }

.cadastros{
    float: left;
    width: 100%;
    padding: 1%;
    position: relative;


  /* width: 100%;
  position: relative */
}

.cadastros h1{
  font-size: 25px;
  font-weight: 300;
  text-align: center;
  line-height: 35px;
  color: #565656
}
.bola{
    width: 20px;
    height: 20px;
    margin: 0 auto;
    background-color: #c9c9c9;
    border-radius: 10px;
}
.CINZA{
    background-color: #c9c9c9 !important;
}
.VERDE{
    background-color: #66ff50 !important;
}
.AMARELO{
    background-color: #ffe450 !important;
}
.VERMELHO{
    background-color: #fd3e3e !important;
}
.cadastros h1 span{
    display: block;
    font-weight: 900
}
#pesq button{
    padding: 12px 20px
}
#pesq input[type="text"]{
    /* padding: 23px; */
}
#filtros{
    float: left;
    width: 100%;
    padding: 1% 1% 4% 1%;
    border: 1px #ddd solid;
    border-radius: 5px;
    position: relative
}
.clear{
    clear:both;
    width: 100%;
    height: 15px;
    color: #fff
}

.tab-content>.tab-pane{
    float: left;
    width: 100%;
}

.tab-content > .active {
    padding: 20px 10px;
    border-left: 1px #ddd solid;
    border-right: 1px #ddd solid;
    border-bottom: 1px #ddd solid;
}
.nav-tabs{
    font-size: 14px;
    color: #333
}
.nav-link {
    color: #333;
}
.selects{
    border: 1px solid #ced4da;
    width: 100%;
    appearance: none;
    border-radius: .25rem;
    float: left;
    padding: 10px;
    height:205px;
    overflow: auto;
    font-size: 13px;
    text-align: left;
}
.btnfor{
    position: relative;
    bottom:5%;
    right: 1%;
}
#dash{
    text-align: center;
    align-items: center;
}
.campos40 {
    width: 30%;
    float: left;
    padding: 10px;
    position: relative;
}

.campos30{
    width: 30%;
    padding: 10px;
    display: inline-block;
    float: none;
    margin-right: 15px;
}

.form-control-filtro {
    width: 100%;
    padding: 12px 10px;
    border-radius: 5px;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
}

.form-control-filtro::placeholder {
  color: #495057;
}

.botao-filtro {
    background: #043c54 !important;
    padding: 0.5rem 1.4rem;
    font-size: .64rem;
    color: #FFF;
    border-radius: 3px;
    text-transform: uppercase;
    transition: all 0.5s;
    border: 0;
    box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%)
}

.botao-filtro:hover { 
    filter: brightness(1.2);
}

#marta1, #marta2, #marta3{
    display:none
}
.visivel{
    display: block!important
}
#resultado{
    width: 100%;
}
#resultado table.table th, table.table td{
    font-size: 12px;
}
#resultado small{
    display: none
}
.tabresp{
    width: 100%;   
    .row {
        margin-right: auto !important;
        margin-left: auto !important;
        width: 100%;
    }
    .custom-select {
        width: auto;
    }
    .form-control {
        width: auto;
    }
    .col-sm-12, .col-sm-6 {
        padding-right: 0px; 
        padding-left: 0px;
    }
    .pagination {
        justify-content: end;
        .page-item {
            cursor: pointer;
        }
    }
}
#infos{
    float: left;
    width: 100%;
    padding: 2% 0;
    text-align: center;
}
#infos section{     
    display: inline-block;
    width: 10%;
    text-align: center;
    font-size: 15px;
    padding: 20px 0;
    border: 1px #ddd solid;
    margin: 5px;
    border-radius: 0.25rem;
}
#infos section p{
 padding: 0 20px;
}

#infos section strong{
    font-weight: 900;
    font-size: 30px;
    display: block;
    color: #043c54;
}
#infos section span{
    display: block;
}
@media only screen and  (max-width: 1440px) {
    #infos section {
        width: 14%;
    }
}
@media only screen and  (max-width: 1024px) {
    
    #infos section {
        width: 18%;
    }
}
@media only screen and  (max-width: 801px) {
    .cadastros .tab-content{
        width: auto;
    }

    .campos30, .campos40 {
        width: 100% ;
        margin-right: 0px;
    }

    .campos40 .form-group {
        width: 100%;
    }

    .tabresp .col-md-6 {
        justify-content: flex-start !important;
        margin-bottom: 20px;

    }

    .tabresp{    
        overflow-x: auto;
        height: 756px
    }

    #filtros{
        border: none;
    }
    
    #infos section{
      width: 25%;
    }
    table td{
        font-size: 12px;
        padding: 5px;
    }
    .cadastros h1 {
        font-size: 20px;
        line-height: 30px;
    }
    
    #resultado small{
        display: block;
        float: left;
        margin: 10px;
    }
}
@media only screen and  (max-width: 480px) {
    #infos section {
        width: 45%;
    }
    }
`; 